<mat-toolbar class="mat-elevation-z1">
  <!-- Menu Toggle Button -->
  <button mat-icon-button id="menu" (click)="navService.toggleNav()" matTooltip="Toggle Navigation">
    <mat-icon>menu</mat-icon>
  </button>

  <!-- Organization Name -->
  <div class="admin-head">
    <div class="orgname">
      {{Corp.OrgName}}
    </div>

    <!-- Branch Selection -->
    <div *ngIf="showBranchSelection" class="branch-selector">
      <mat-select [disabled]="!isAdminUser"
                  #units
                  placeholder="Branch"
                  (opened)="units.placeholder=''"
                  (closed)="units.value === undefined?units.placeholder='Branch':''"
                  (selectionChange)="changeBranch($event.value)"
                  [(ngModel)]="selectedUnit">
        <mat-option *ngFor="let u of Corp.OrgUnits" [value]="u">
          {{u.UnitName}}
        </mat-option>
      </mat-select>
    </div>

    <!-- Right Section: Theme Switcher, User Info, Logout -->
    <div class="loggedin-user-section">
      <!-- Theme Switcher -->
      <app-theme-switcher></app-theme-switcher>

      <!-- User Info -->
      <div class="loggedin-user">
        <div class="user-name">{{LoggedInUser.FirstName}} {{LoggedInUser.LastName}}</div>

        <!-- Logout Button -->
        <button type="button"
                mat-icon-button
                class="logout-btn"
                title="Logout"
                matTooltip="Logout"
                (click)="logout($event)"
                [disabled]="isLoggingOut"
                aria-label="Logout">
          <mat-icon class="form-icons">logout</mat-icon>
        </button>
      </div>
    </div>
  </div>
</mat-toolbar>
